import { FieldMap } from '../../../types/forms/fields'
import { getBooleanHistoryField } from '../../shared'

export const immunizationsField: FieldMap = {
  name: 'Immunizations',
  children: {
    upToDate: getBooleanHistoryField('Are you up to date on your vaccines?'),
    seeingProviderForVaccinesToday: getBooleanHistoryField(
      'Are you seeing your provider today for vaccines?',
    ),
    wantsInformation: getBooleanHistoryField(
      'Do you want information from your provider about vaccines?',
    ),
  },
}
